<c-card *transloco="let t">

  @if(billing && billing.plan.reseller && billing.plan.hide_accounts){

    <c-card-body>
      <c-row>
        <c-col md="12">
          <h1>{{ t('Account Settings') }}</h1>

  
          <p>
            {{ t('Your account and billing is managed by your Reseller. Please contact them to make any changes.') }}
          </p>
  
          <p>
              {{ t('Alternatively, If you have any queries about your account, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
          </p>
  
        </c-col>
      </c-row>
      </c-card-body>

    }

    @else if(billing && billing.plan.hide_accounts){

        <c-card-body>
          <c-row>
            <c-col md="12">
              <h1>{{ t('Account Settings') }}</h1>
  
              <p>
                {{ t('Your account and billing is managed by your sales representative. ') }} {{ t('If you have any queries about your account, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
              </p>
      
            </c-col>
          </c-row>
          </c-card-body>

      }

      @else{

        
      <ng-container>


        <c-card-body *ngIf="billing">
    
                <c-row>
                  <c-col md="12">
                    <h1>{{ t('Account Settings') }}</h1>
    
                    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('account_live')">
                      <i class="fa-solid fa-circle-check"></i> {{ t('Your OK Alone account is live and ready for you to use.') }}
                      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('account_live')"></button>
                    </div>
    
                    <p>
                      {{ t('You can use this page to manage your plan, view invoices and update your billing details.') }}
                    </p>
                    <p>
                        {{ t('If you have any queries about your account, please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
                    </p>
    
    
                  </c-col>
                </c-row>
    
    
        <ul class="nav nav-tabs">
          <li class="nav-item"  *ngIf="okService.billing.contract_signing && okService.billing.contract_signing.uses_new_contract_system && okService.billing.contract_signing.signing_required">
            <a class="nav-link" (click)="tab='signup'" [class.active]="tab=='signup'">{{ t('Sign your OK Alone Contract') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="tab='plan'" [class.active]="tab=='plan'">{{ t('Your Plan') }}</a>
          </li>
          <li class="nav-item" *ngIf="billing.plan">
            <a class="nav-link" (click)="tab='invoices'" [class.active]="tab=='invoices'">{{ t('Your Invoices & Statements') }}</a>
          </li>
          <li class="nav-item"  *ngIf="billing.plan && !billing.plan.hide_credit_card">
            <a class="nav-link" (click)="tab='card'" [class.active]="tab=='card'">{{ t('Update your Credit Card Details') }}</a>
          </li>
        </ul>
        <br/>
        <ng-container *ngIf="tab == 'plan'">
          @if (okService.billing.plan.account_type == "Pricing2024") {
            <app-account-plan-2024></app-account-plan-2024>
          }
          @else {
            <app-account-plan></app-account-plan>
          }
        </ng-container>
    
    
      <ng-container *ngIf="tab == 'invoices'">
    
        <c-row *ngIf="billing.invoices && billing.invoices.length>0">
          <c-col md="12">
              <h1>{{ t('Your Invoices & Statements') }}</h1>
            <p>
            {{ t('Below are your invoices, showing which are paid and which are due.') }}
            </p>
            <table
            [hover]="true"
            [responsive]="true"
            [striped]="true"
            align="middle"
            cTable
            class="mb-0 border"
            >
              <thead>
                <tr>
                  <th scope="col">{{ t('Date') }}</th>
                  <th scope="col">{{ t('Order ID') }}</th>
                  <th scope="col">{{ t('Amount') }}</th>
                  <th scope="col">{{ t('Status') }}</th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let invoice of billing.invoices">
    
                    <td>
                      <h5>{{invoice.date_str}}</h5>
                    </td>
                    <td>
                      {{invoice.order_id}}
                    </td>
                    <td>
                      <h5>{{invoice.currency}}{{invoice.total}}</h5>
                    </td>
                    <td>
                      <button *ngIf="invoice.paid" type="button" class="btn btn-success text-white">{{ t('Paid') }}</button>
                      <button *ngIf="!invoice.paid && invoice.overdue" type="button" class="btn btn-danger text-white">{{ t('Overdue') }}</button>
                      <button *ngIf="!invoice.paid && !invoice.overdue" type="button" class="btn btn-info text-white">{{ t('Due Soon') }}</button>
                    </td>
                    <th scope="col">
                      <a class="btn btn-outline-info" target="_viewinvoice" href="{{invoice.link}}">{{ t('View') }} <svg cIcon  name="cil-description"></svg></a>
                    </th>
    
                  </tr>
                </tbody>
    
            </table>
    
    
          </c-col>
        </c-row>
    
          <br/>
          <hr/>
    
          <c-row>
            <c-col md="12">
                <h2>{{ t('Invoices & Statements Emails') }}</h2>
                <p>
                {{ t('Your invoices and statements will be sent to the following email addresses') }}
                </p>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <ul class="list-group" >
                      <li class="list-group-item"  *ngFor="let email of billing.plan.emails">{{email}} <button type="button" class="btn btn-danger btn-sm text-white" (click)="deleteEmail(email)"><i class="fa-solid fa-trash"></i></button></li>
                    </ul>
                  </div>
                  <div class="col-12 col-md-6">
    
                    <p>{{ t('Add an email address here:') }}</p>
                    <div class="input-group">
                      <span class="input-group-text"><i class="fa-solid fa-envelope"></i></span>
                      <input type="text" class="form-control" placeholder="{{ t('Email address') }}" aria-label="Email address" [(ngModel)]="email">
                    </div>
                    <button type="submit" class="btn btn-info text-white" (click)="addEmail()" ><i class="fa-solid fa-plus"></i>  {{ t('Add Email') }}</button>
                  </div>
    
                </div>
              </c-col>
            </c-row>
    
      </ng-container>
    
    
    
      <ng-container *ngIf="tab == 'card'">
        <div id="go_to_card"></div>
        <app-account-card></app-account-card>
    
      </ng-container>

      <ng-container *ngIf="tab == 'signup'">
        <app-account-signup></app-account-signup>
      </ng-container>
    </c-card-body>
  </ng-container>

      }


  

</c-card>

